"use client"

import type React from "react"
import { Dialog, DialogContent, DialogTitle, IconButton, Typography, Box, useMediaQuery, useTheme } from "@mui/material"
import { IconX } from "@tabler/icons-react"
import { getStatusDescription } from "../types"

interface InfoModalProps {
    onClose: () => void
}

const InfoModal: React.FC<InfoModalProps> = ({ onClose }) => {
    const theme = useTheme()
    const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"))

    return (
        <Dialog
            open={true}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            fullScreen={isSmallMobile}
            PaperProps={{
                sx: {
                    borderRadius: isSmallMobile ? 0 : 2,
                    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
                    margin: isSmallMobile ? 0 : 2,
                },
            }}
        >
            <DialogTitle
                sx={{
                    textAlign: "center",
                    color: "#0d6336",
                    fontWeight: 600,
                    pt: 4,
                    pb: 2,
                }}
            >
                Estado de los Cuadritos
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        color: "white",
                        backgroundColor: "#3c2a20",
                        "&:hover": {
                            backgroundColor: "#0d6336",
                        },
                    }}
                >
                    <IconX size={20} />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ px: { xs: 2, sm: 4 }, pb: 4 }}>
                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" color="primary" sx={{ mb: 1, fontWeight: 600 }}>
                        Listo para entrega
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
                        {getStatusDescription("ready")}
                    </Typography>
                </Box>

                <Box>
                    <Typography variant="h6" color="primary" sx={{ mb: 1, fontWeight: 600 }}>
                        Sin resina
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
                        {getStatusDescription("pending")}
                    </Typography>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default InfoModal

